(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ellitane-cookie-banner"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('ellitane-consent');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const banner = root.querySelector('.ec-banner');
  const dialog = root.querySelector('.ec-dialog');
  const purposes = ['preferences', 'analytics', 'marketing'];
  const preview = root.querySelector('.ec-preview');
  const isPreview = preview && new URLSearchParams(location.search).get('ellitane_cookie_preview') === '1';
  let api, busy = false, opener;
  function showError() {
    root.querySelectorAll('.ec-error').forEach(el => { el.textContent = root.dataset.error; el.hidden = false; });
  }
  function showBanner() {
    banner.hidden = false;
    document.documentElement.classList.add('ec-locked');
    const accept = banner.querySelector('.ec-accept');
    if (accept) accept.focus({preventScroll:true});
  }
  function hideBanner() {
    banner.hidden = true;
    document.documentElement.classList.remove('ec-locked');
  }
  function closeDialog() { dialog.close(); if (opener && !opener.closest('[hidden]')) opener.focus(); }
  function updatePreview() {
    if (!isPreview) return;
    const consent = api.currentVisitorConsent();
    const output = preview.querySelector('output');
    output.textContent = output.dataset.label + ': ' + purposes.map(key => {
      const label = dialog.querySelector('input[name="' + key + '"]').closest('label').querySelector('strong').textContent;
      return label + ' ' + (consent[key] === 'yes' ? output.dataset.yes : consent[key] === 'no' ? output.dataset.no : '—');
    }).join(' · ');
  }
  function save(values) {
    if (busy) return;
    busy = true;
    root.querySelectorAll('.ec-error').forEach(el => { el.hidden = true; });
    const buttons = root.querySelectorAll('[data-ec-accept], [data-ec-reject], .ec-save');
    buttons.forEach(el => { el.disabled = true; });
    let finished = false;
    const finish = success => {
      if (finished) return;
      finished = true;
      busy = false;
      buttons.forEach(el => { el.disabled = false; });
      if (success) {
        hideBanner();
        if (dialog.open) dialog.close();
        root.querySelector('.ec-reopen').focus({preventScroll:true});
        updatePreview();
      } else showError();
    };
    const timeout = setTimeout(() => finish(false), 10000);
    try {
      api.setTrackingConsent(values, () => {
        clearTimeout(timeout);
        const consent = api.currentVisitorConsent();
        finish(purposes.every(key => consent[key] === (values[key] ? 'yes' : 'no')));
      });
    } catch (_) { clearTimeout(timeout); finish(false); }
  }
  function initialize() {
    api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.shouldShowBanner !== 'function' || typeof dialog.showModal !== 'function') return;
    root.querySelectorAll('[data-ec-accept]').forEach(el => el.addEventListener('click', () => save({preferences:true,analytics:true,marketing:true})));
    root.querySelectorAll('[data-ec-reject]').forEach(el => el.addEventListener('click', () => save({preferences:false,analytics:false,marketing:false})));
    root.querySelectorAll('[data-ec-settings]').forEach(el => el.addEventListener('click', () => {
      opener = el;
      const consent = api.currentVisitorConsent();
      purposes.forEach(key => { dialog.querySelector('input[name="' + key + '"]').checked = consent[key] === 'yes'; });
      dialog.showModal();
    }));
    root.querySelector('.ec-close').addEventListener('click', closeDialog);
    root.querySelector('.ec-save').addEventListener('click', () => save(Object.fromEntries(purposes.map(key => [key,dialog.querySelector('input[name="' + key + '"]').checked]))));
    const shouldShow = api.shouldShowBanner();
    document.documentElement.classList.add('ec-consent-ready');
    root.querySelector('.ec-reopen').hidden = false;
    const consent = api.currentVisitorConsent();
    const hasDecision = purposes.every(key => consent[key] === 'yes' || consent[key] === 'no');
    if ((shouldShow && !hasDecision) || isPreview) showBanner();
    if (isPreview) {
      preview.hidden = false;
      preview.querySelector('button').addEventListener('click', showBanner);
      updatePreview();
    }
    document.addEventListener('visitorConsentCollected', () => {
      if (!isPreview) hideBanner();
      updatePreview();
    });
  }
  let attempts = 0;
  function load() {
    if (window.Shopify && window.Shopify.customerPrivacy) return initialize();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) initialize(); });
    } else if (++attempts < 40) setTimeout(load, 250);
  }
  load();
})();
  } catch(e) { console.error(e); }
})();

})();
